import React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import Button from "@amzn/awsui-components-react/polaris/button";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Input from "@amzn/awsui-components-react/polaris/input";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { useMarketplaceSelector } from "../../components/MarketplaceSelector";
import useQueryOfferConfiguration from "../../Api/useQueryOfferConfiguration";
import OfferConfigurationPageResult from "./offerConfigurationPageResult";

const OfferConfigurationPage = () => {
  const { marketplace, MarketplaceSelector } = useMarketplaceSelector(null);
  const [merchantId, setMerchantId] = React.useState("");
  const [asin, setAsin] = React.useState("");
  const [sku, setSku] = React.useState("");
  const [fmId, setFmId] = React.useState("");
  const {
    isFetching,
    data: offerConfigurationResponse,
    refetch,
  } = useQueryOfferConfiguration({ marketplace, merchantId, asin, sku, fmId });

  const handleSubmit = () => {
    refetch();
  };

  return (
    <SpaceBetween direction="vertical" size="xxl">
      <Container
        header={<Header variant="h2">Configuration Details</Header>}
        footer={
          <Button variant="primary" loading={isFetching} onClick={handleSubmit}>
            Enable IBA Configuration
          </Button>
        }
      >
        <SpaceBetween direction="vertical" size="m">
          <FormField label="Marketplace ID" stretch>
            <MarketplaceSelector />
          </FormField>
          <FormField label="Merchant ID" stretch>
            <Input
              value={merchantId}
              onChange={({ detail }) => setMerchantId(detail.value)}
              placeholder="Enter Merchant ID"
            />
          </FormField>
          <FormField label="ASIN" stretch>
            <Input value={asin} onChange={({ detail }) => setAsin(detail.value)} placeholder="Enter ASIN" />
          </FormField>
          <FormField label="SKU" stretch>
            <Input value={sku} onChange={({ detail }) => setSku(detail.value)} placeholder="Enter SKU" />
          </FormField>
          <FormField label="FMID" stretch>
            <Input value={fmId} onChange={({ detail }) => setFmId(detail.value)} placeholder="Enter FMID" />
          </FormField>
        </SpaceBetween>
      </Container>
      {offerConfigurationResponse && <OfferConfigurationPageResult response={offerConfigurationResponse} />}
    </SpaceBetween>
  );
};

export default OfferConfigurationPage;
